<form #form="ngForm" role="group" [ngClass]="styles.dtmfForm" (submit)="onSubmit()">
	<vb-ui-form-group [ngClass]="styles.formGroup">
		<label #uiLabel id="webcastDtmf">{{ 'DTMF_Webcast_Label' | translate }}</label>
		<input type="text" uiControl class="form-control" name="webcastDtmf" [(ngModel)]="dtmfCode" (ngModelChange)="onChange()" [pattern]="SINGLE_DTMF_CODE_REGEX" [placeholder]="'DTMF_Placeholder' | translate" required #dtmfCodeControl="ngModel">
		<div *ngIf="dtmfCodeControl.touched &&
			dtmfCodeControl.errors &&
			!dtmfCodeControl.errors.required" role="alert" vbUiErrorMessage uiValidation>
			@if (dtmfCodeControl.errors.pattern) {
				{{ 'DTMF_InitialCodesError' | translate }}
			} @else if (dtmfCodeControl.errors.codeToReject) {
				{{ 'DTMF_Rejected' | translate }}
			}
		</div>
	</vb-ui-form-group>
	<button type="submit" [disabled]="form.invalid" [ngClass]="styles.submitButton" vbBtnPrimary>
		{{ 'Submit' | translate }}
	</button>
</form>

<div [ngClass]="styles.prevCodeContainer">
	<span>{{ 'DTMF_PreviouslyEntered' | translate }}</span>
	<ol reversed>
		<li *ngFor="let code of previousCodes" [ngClass]="styles.prevCode">
			{{ code }}
		</li>
	</ol>
</div>
